export enum SiteWarehouse {
    SITE = 'SITE',
    WAREHOUSE = 'WAREHOUSE'
}